const allBalanceSummary = { data: [], loading: true };
const allChargeHeadInvoices = { data: [], loading: true };
const allChargeHeadSummary = { data: [], loading: true };

export const GetAllBalanceSummary = (state = allBalanceSummary, action) => {
  switch (action.type) {
    case "get_balancesummary":
      return {
        data: action?.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllChargeHeadInvoices = (state = allChargeHeadInvoices, action) => {
  switch (action.type) {
    case "get_chargeheadinvoices":
      return {
        data: action?.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllChargeHeadSummary = (state = allChargeHeadSummary, action) => {
  switch (action.type) {
    case "get_chargeheadsummary":
      return {
        data: action?.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
